import React from 'react';
import { TableBody, TableCell, Table, TableHead, TableRow, Box, Paper } from '@material-ui/core';
import { useStore } from 'react-redux';
import { useScreen } from 'global/styles';
import TypoLabel from 'global/components/typo-label';
import useStyles from './TableHeader.styles';

export default function (props) {
  const { columns } = props;
  const classes = useStyles();
  const sState = useStore().getState();
  const { isMobile } = useScreen();

  return (
    <Box className={classes.paper} component={Paper}>
      {isMobile ? (
        <div className={classes.mobile}>
          {columns.map((col, i) => (
            <TypoLabel key={i} primary={`${col.title}: `} secondary={col.val({ ...props, sState })} />
          ))}
        </div>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              {columns.map((col, i) => (
                <TableCell key={i}>{col.title}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              {columns.map((col, i) => (
                <TableCell key={i}>{col.val({ ...props, sState })}</TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      )}
    </Box>
  );
}
